import React from "react";
import { useI18n } from "@/i18n";

export const LangToggle = ({ className = "" }) => {
  const { lang, setLang } = useI18n();
  return (
    <div
      data-testid="lang-toggle"
      className={`flex items-center text-[11px] font-medium tracking-[0.2em] uppercase ${className}`}
    >
      <button
        type="button"
        onClick={() => setLang("pl")}
        data-testid="lang-pl"
        aria-pressed={lang === "pl"}
        className={`px-1.5 transition-colors duration-300 ${
          lang === "pl" ? "text-canvas" : "text-canvas/50 hover:text-canvas/80"
        }`}
      >
        PL
      </button>
      <span className="text-canvas/40">|</span>
      <button
        type="button"
        onClick={() => setLang("en")}
        data-testid="lang-en"
        aria-pressed={lang === "en"}
        className={`px-1.5 transition-colors duration-300 ${
          lang === "en" ? "text-canvas" : "text-canvas/50 hover:text-canvas/80"
        }`}
      >
        EN
      </button>
    </div>
  );
};

export default LangToggle;
